import { GasMeterClass } from '../../common/enums/shared/gas-meter-class';

export const DEFAULT_GAS_METER_CLASS = GasMeterClass.G4;
export const DEFAULT_GAS_POTENTIAL = 29;
export const DEFAULT_GAS_VENDOR_CODE = 'G00088';
